import { operations } from "types/openapi";
import { api } from "./api";
import { ENDPOINTS } from "./endpoints";

export type RetryExecutionParams = operations["retryExecution"]["parameters"]["path"];

/** Повторить транзакцию */
export const retryTransaction = (id: string): Promise<RetryExecutionParams> => {
  return api.post(ENDPOINTS.retryTransaction(id));
};
